export default __webpack_public_path__ + "static/media/Element2.47b04965.png";